import axios from 'axios';
import { toast } from 'react-toastify';
import { LoadingToast } from '../components/utils';

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.common["Accept"] = "*/*";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.put["Content-Type"] = "application/json";
const token = localStorage.getItem("token");
if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
const host = window.location.host;
const origin = (host.includes('.') && host.split('.')[0] === 'mobile') ? 'Mobile' : 'Vision';
axios.defaults.headers.common["Origin-Type"] = origin;
const onResponse = (response) => {
	toast.dismiss('loading_toast');
	if(response.status >= 200 || response.status < 300)
	{
		const messages = response.data.message;
		if(typeof messages !== 'undefined' && messages.length > 0)
		{
			if(Array.isArray(messages))
			{
				for(var key in messages)
				{
					toast.success(messages[key]);
				}
			}
			else
			{
				toast.success(messages);
			}
		}
	}
	if(response.config && response.config.responseType === 'blob')
	{
		return response.data ? response.data : false;
	}
	return response.data && Object.keys(response.data.data).length ? response.data.data : false;
}

const onError = (error) => {
	toast.dismiss('loading_toast');
	if(error.response.status < 200 || error.response.status >= 300)
	{
		const messages = error.response.data.message;
		if(typeof messages !== 'undefined' && messages.length > 0)
		{
			if(Array.isArray(messages))
			{
				for(var key in messages)
				{
					toast.error(messages[key]);
				}
			}
			else
			{
				toast.error(messages);
			}
		}
		// return error.response;
		return Promise.reject(error.response);
	}
}

axios.interceptors.request.use( req => {
	LoadingToast();
	return req;
});

axios.interceptors.response.use(onResponse, onError);

const api = {
	get: axios.get,
	post: axios.post,
	put: axios.put,
	delete: axios.delete
};
export default api;
